module.exports = __webpack_public_path__ + "img/Satertriathlon_logo_vit.1d9031f0.jpg";